import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from "vue"
import AppDetailPage from "@/components/layout/AppDetailPage.vue"

import {
  MyInvoiceQuery,
  MyInvoiceQueryQuery,
  MyInvoiceQueryQueryVariables,
  ConsultantInvoice,
} from "@/gql"
import { useQuery } from "@vue/apollo-composable"
import { PageState } from "@/constants"
import { usePageState } from "@/hooks/usePageState"
import PageStateError from "@/components/widgets/common/PageStateError.vue"
import useRouter from "@/router/useRouter"
import ConsultantInvoiceDetail from "@/modules/Invoicing/components/ConsultantInvoiceDetail.vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'ConsultantInvoiceDetailPage',
  setup(__props) {

const { router } = useRouter()

const pageState = ref(PageState.Loading)
const { handlePageErrorState } = usePageState(pageState)

const { loading, result, onError } = useQuery<MyInvoiceQueryQuery, MyInvoiceQueryQueryVariables>(
  MyInvoiceQuery,
  {
    filter: { idIn: [`ConsultantInvoice:${router.currentRoute.params.id}`] },
  }
)

const invoice = computed(
  () => result.value?.consultantProfile?.consultantInvoices?.[0] as ConsultantInvoice
)

onError((error) => {
  handlePageErrorState(error)
})

return { __sfc: true,router, pageState, handlePageErrorState, loading, result, onError, invoice, AppDetailPage, PageState, PageStateError, ConsultantInvoiceDetail }
}

})